import { Box, ColorOptions, IconNew, SpacerNew, TextNew, useWindowDimensions } from '@jfs/ui-new'
import { memo, useState } from 'react'
import { DropdownOptimised } from '../../../../comps/DropdownNew'
import { DropdownTypes } from '../../../../comps/DropdownNew/types'
import { styles } from './ReportingStyles'

export const FrequencyData = [
  { id: '1', value: 'DAILY' },
  { id: '2', value: 'MONTHLY' },
  { id: '3', value: 'WEEKLY' },
  { id: '4', value: 'FORTNIGHTLY' },
]

export const Validity = [
  { id: '1', value: '10 days' },
  { id: '2', value: '1 month' },
  { id: '3', value: '3 months' },
  { id: '4', value: '6 months' },
  { id: '5', value: 'Yearly' },
  { id: '6', value: 'Until Cancelled' },
]

export const FileTransferData = [
  { id: '1', value: 'EMAIL' },
  { id: '2', value: 'SFTP' },
  { id: '3', value: 'SFTP & EMAIL' },
]

export const getReportExtensions = (type: string = '') => {
  let extentions = [
    { id: 1, value: 'XLSX' },
    { id: 2, value: 'CSV' },
    { id: 3, value: 'TXT' },
  ]
  // if (type === 'Custom RRL') {
  //   delete extentions[2]
  // }
  return extentions
}
export const ReportFormat = [
  { id: 1, value: 'Standard' },
  { id: 2, value: 'Custom' },
  { id: 3, value: 'Custom RRL' },
]
export const ReportTypes = [{ id: 1, value: 'Settlements' }]

const InfoDropdown = ({ data, placeHolder, title, dropdownValue, toggleReportValue }: any) => {
  const width = useWindowDimensions()
  return (
    <Box {...styles.mainView}>
      <Box {...styles.textAndIcon}>
        <Box {...styles.titleAligner}>
          <TextNew title={title} {...styles.titleText} />
        </Box>
        <Box {...styles.iconContainer}>
          <IconNew id={'INFO'} color={'#202F4D8A' as ColorOptions} size={14} />
        </Box>
      </Box>
      <SpacerNew size={5} direction={'vertical'} />
      <Box {...styles.superContainer}>
        <DropdownOptimised
          placeHolder={placeHolder}
          data={data}
          value={dropdownValue}
          type={DropdownTypes.DEFAULT_DOWNLOAD_REPORT}
          onChange={(val: any) => toggleReportValue(val)}
          buttonWidth={width / 5}
          disabled={false}
          titleColor={dropdownValue !== undefined ? 'BLACK_21' : 'LIGHT_GREY_INTRO'}
          borderColor={'#B9CBF0' as ColorOptions}
          testID={placeHolder + 'test'}
          dropdownWidth={width / 5}
        />
      </Box>
    </Box>
  )
}

export const ReportFrequency = memo(({ setFieldValue, fieldName, allValues }) => {
  const FREQUENCY_VALUE = allValues?.reportFrequencyAndValidity?.[0] ?? undefined
  const REPORT_VALUE = allValues?.reportFrequencyAndValidity?.[1] ?? undefined
  const FILE_TRANSFER_MODE = allValues?.reportFrequencyAndValidity?.[2] ?? undefined

  const [frequencyValue, toggleFrequencyValue] = useState(FREQUENCY_VALUE)
  const [reportValidity, toggleReportValue] = useState(REPORT_VALUE)
  const [fileTransferValue, toggleFileTransferValue] = useState(FILE_TRANSFER_MODE)

  return (
    <Box flexDirection={'row'}>
      <InfoDropdown
        data={FrequencyData}
        placeHolder={'Select Report frequency'}
        title={'Report Frequency'}
        dropdownValue={frequencyValue}
        toggleReportValue={(val) => {
          toggleFrequencyValue(val)

          if (setFieldValue && fieldName && val && reportValidity) {
            setFieldValue(fieldName, [val, reportValidity])
          }
        }}
      />
      <SpacerNew size={30} direction={'horizontal'} />
      <InfoDropdown
        data={Validity}
        placeHolder={'Select Report Validity'}
        title={'Report Validity'}
        dropdownValue={reportValidity}
        toggleReportValue={(val) => {
          toggleReportValue(val)

          if (setFieldValue && fieldName && frequencyValue && val) {
            setFieldValue(fieldName, [frequencyValue, val])
          }
        }}
      />
      <SpacerNew size={30} direction={'horizontal'} />
      <InfoDropdown
        data={FileTransferData}
        placeHolder={'Select File Transfer Mode'}
        title={'File Transfer Mode'}
        dropdownValue={fileTransferValue}
        toggleReportValue={(val) => {
          toggleFileTransferValue(val)
          console.log('fieldName', fieldName)
          console.log('selected val', val)
          console.log('allvalues', allValues)

          if (setFieldValue && fieldName && fileTransferValue && val) {
            setFieldValue(fieldName, [fileTransferValue, val])
          }
        }}
      />
    </Box>
  )
})
